// import Vue from 'vue'
import sku from './sku.vue'
// import VueI18n from 'vue-i18n';
// import zh from '@/config/zh.json';
// import en from '@/config/en.json';

// Vue.use(VueI18n);
// const DEFAULT_LANG = 'en';
// const locales = {
//     'zh-cn': zh,
//     en,
// };
// const i18n = new VueI18n({
//     locale: DEFAULT_LANG,
//     messages: locales,
// });

// const dialog = Vue.extend(sku)
// let instance
// sku.open = function (input) {
//     if (!instance) {
//         instance = new dialog({
//             i18n
//         }).$mount()
//     }
//     document.body.appendChild(instance.$el);
//     Vue.nextTick(() => {
//         instance.open(input);
//     });
// };
// sku.close = function () {
//     Vue.nextTick(() => {
//         if (instance) {
//             instance.$destroy()
//         }
//         if (instance) {
//             instance = null;   
//         }
//     });
// }
// export default sku



export default {
    install(Vue, i18n){
        const dialog = Vue.extend(sku)
        let instance
        sku.open = function (input) {
            if (!instance) {
                instance = new dialog({
                    i18n
                }).$mount()
            }
            document.body.appendChild(instance.$el);
            Vue.nextTick(() => {
                instance.open(input);
            });
        };
        sku.close = function () {
            Vue.nextTick(() => {
                if (instance) {
                    instance.$destroy()
                }
                if (instance) {
                    instance = null;   
                }
            });
        }
        Vue.prototype.$sku = sku;
    }
}